export default {"src":"/_next/static/media/usdc-outline.1297fc14.svg","height":41,"width":41};